module.exports = __webpack_public_path__ + "img/mouzik2016-min.ddb9304d.jpg";